import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { API } from "../constants";

export const PhotoUpload = ({ onUpload, folder, multiple = false }) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    
    setUploading(true);
    try {
      const uploadPromises = files.map(async (file) => {
        const sigRes = await axios.get(`${API}/cloudinary/signature?folder=${folder}`);
        const sig = sigRes.data;
        
        const form = new FormData();
        form.append("file", file);
        form.append("api_key", sig.api_key);
        form.append("timestamp", sig.timestamp);
        form.append("signature", sig.signature);
        form.append("folder", sig.folder);
        
        const uploadRes = await fetch(
          `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`,
          { method: "POST", body: form }
        );
        
        return uploadRes.json();
      });
      
      const results = await Promise.all(uploadPromises);
      const urls = results.map(r => r.secure_url);
      onUpload(multiple ? urls : urls[0]);
      toast.success("Foto subida exitosamente");
    } catch (err) {
      toast.error("Error al subir foto");
    } finally {
      setUploading(false);
    }
  };

  return (
    <label className={`upload-zone ${uploading ? "opacity-50 pointer-events-none" : ""}`}>
      <input
        type="file"
        accept="image/*"
        multiple={multiple}
        onChange={handleUpload}
        className="hidden"
        data-testid="photo-upload-input"
      />
      <Camera className="w-10 h-10 mx-auto mb-2 text-zinc-500" />
      <p className="text-zinc-400">
        {uploading ? "Subiendo..." : "Haz clic para subir fotos"}
      </p>
    </label>
  );
};

export default PhotoUpload;
